var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[_c('img',{attrs:{"src":"https://imgcdn.chuxingyouhui.com/blackunique/upload/cae0b76bab79035a9037f71b347099c5.png"}}),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.resultInfo.prizeDescription)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }